import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col, Table } from 'reactstrap';
import { getRendicionFondosById } from '../../helpers/api_helper';
import { useSelector } from 'react-redux';
import useUpdateRendicionFondos from '../../Components/Hooks/useUpdateRendicionFondos';

const ModalModificarRendicionFondos = ({ isOpen, toggle, onSave, selectedRendicion }) => {
    const [formData, setFormData] = useState({
        encabezadoData: {
            CLAEMP: '',
            TIPFOL: '',
            NUMFOL: '',
            CENRES: '',
            FECMOV: '',
            CLIPRO: '',
            VALENT: '',
            VALREN: '',
            TIPCOM: '',
            NUMCOM: '',
            TIPREN: '',
            DESCRI: '',
            TIPEGR: '',
            EGRESO: '',
            TIPING: '',
            ORIGEN: '',
            USUACT: ''
        },
        detallesData: []
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const { updateRendicion, loading: updateLoading } = useUpdateRendicionFondos();

    useEffect(() => {
        if (isOpen && selectedRendicion) {
            const [tipfol, numfol] = selectedRendicion.split('-');
            fetchRendicionData(tipfol, numfol);
        }
    }, [isOpen, selectedRendicion, tenantId]);

    const fetchRendicionData = async (tipfol, numfol) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getRendicionFondosById(tipfol, numfol, { tenantId });

            setFormData({
                encabezadoData: response.encabezado,
                detallesData: response.detalles || []
            });
        } catch (err) {
            setError(`Error al cargar los datos: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (!date) return '';
        const _date = new Date(date);
        const year = _date.getFullYear();
        const month = String(_date.getMonth() + 1).padStart(2, '0');
        const day = String(_date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (e, section) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [name]: value
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const [tipfol, numfol] = selectedRendicion.split('-');
        const result = await updateRendicion(tipfol, numfol, formData);
        if (result.success) {
            alert('Rendición actualizada exitosamente');
            onSave();
            toggle();
        } else {
            alert('Error al actualizar rendición: ' + result.error);
        }
    };

    const handleToggle = () => {
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleToggle} size="lg">
            <ModalHeader toggle={handleToggle}>Modificar Rendición de Fondos</ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {loading ? (
                        <div className="text-center">Cargando...</div>
                    ) : error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <>
                            <h6>Encabezado</h6>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="CLAEMP">Empresa</Label>
                                        <Input
                                            type="number"
                                            name="CLAEMP"
                                            id="CLAEMP"
                                            value={formData.encabezadoData.CLAEMP || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="TIPFOL">Tipo Folio</Label>
                                        <Input
                                            type="text"
                                            name="TIPFOL"
                                            id="TIPFOL"
                                            value={formData.encabezadoData.TIPFOL || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="NUMFOL">N° Folio</Label>
                                        <Input
                                            type="number"
                                            name="NUMFOL"
                                            id="NUMFOL"
                                            value={formData.encabezadoData.NUMFOL || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="FECMOV">Fecha Movimiento</Label>
                                        <Input
                                            type="date"
                                            name="FECMOV"
                                            id="FECMOV"
                                            value={formData.encabezadoData.FECMOV ? new Date(formData.encabezadoData.FECMOV).toISOString().split('T')[0] : ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="CLIPRO">Cliente Proveedor</Label>
                                        <Input
                                            type="text"
                                            name="CLIPRO"
                                            id="CLIPRO"
                                            value={formData.encabezadoData.CLIPRO || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="VALENT">Valor Entregado</Label>
                                        <Input
                                            type="number"
                                            name="VALENT"
                                            id="VALENT"
                                            value={formData.encabezadoData.VALENT || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="VALREN">Valor Rendición</Label>
                                        <Input
                                            type="number"
                                            name="VALREN"
                                            id="VALREN"
                                            value={formData.encabezadoData.VALREN || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="DESCRI">Descripción</Label>
                                        <Input
                                            type="textarea"
                                            name="DESCRI"
                                            id="DESCRI"
                                            value={formData.encabezadoData.DESCRI || ''}
                                            onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <h6>Detalles</h6>
                            {formData.detallesData && formData.detallesData.length > 0 ? (
                                <Table striped>
                                    <thead>
                                        <tr>
                                            <th>CORFOL</th>
                                            <th>Fecha Mov</th>
                                            <th>Tipo Doc</th>
                                            <th>N° Doc</th>
                                            <th>Valor Total</th>
                                            <th>Descripción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.detallesData.map((detalle, index) => (
                                            <tr key={index}>
                                                <td>{detalle.CORFOL}</td>
                                                <td>{formatDate(detalle.FECMOV)}</td>
                                                <td>{detalle.TIPDOC}</td>
                                                <td>{detalle.NUMDOC}</td>
                                                <td>{detalle.VALTOT?.toLocaleString()}</td>
                                                <td>{detalle.DESCRI}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p>No hay detalles disponibles.</p>
                            )}
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" type="submit" disabled={updateLoading}>
                        {updateLoading ? 'Guardando...' : 'Guardar'}
                    </Button>
                    <Button color="secondary" onClick={handleToggle}>Cancelar</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalModificarRendicionFondos;